module.exports = "<div class=\"inhalt\">\n  <h1 class=\"oben\">Holland</h1><br />\n  <iFrame class=\"site\" src=\"http://www.surfschule-wiesensee.de/test/assets/includes/holland.php\" frameborder=\"0\" scrolling=\"no\"></iFrame>\n  <app-footer></app-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/holland/holland.component.html
// module id = ../../../../../src/app/holland/holland.component.html
// module chunks = main